<template>
  <div id="main-content" class="admin-notification-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="20%">{{ $t('common.title') }}</th>
            <th width="35%">{{ $t('common.content') }}</th>
            <th width="15%">{{ $t('notification.send_type') }}</th>
            <th width="15%">{{ $t('common.time') }}</th>
            <th></th>
          </tr>
          <tr v-for="(adminNotification, index) in adminNotificationList" :key="adminNotification.id"
              v-show="index >= itemPerPage * (page - 1) && index < itemPerPage * page">
            <td>{{ index + 1 }}</td>
            <td>{{ adminNotification.title }}</td>
            <td>{{ adminNotification.content }}</td>
            <td>{{ getSendType(adminNotification.send_type) }}</td>
            <td>{{ $moment(adminNotification.created_at).format('YYYY-MM-DD H:mm:ss') }}</td>
            <td>
              <b-button variant="outline-primary" @click="goToDetail(adminNotification.id)"
                        style="margin-right: 10px">{{ $t('common.detail') }}
              </b-button>
            </td>
          </tr>
        </table>
      </el-row>
      <el-row style="padding-top: 20px">
        <el-pagination
            v-show="adminNotificationList.length > itemPerPage"
            background
            @current-change="didSelectPage"
            :page-size="itemPerPage"
            layout="prev, pager, next"
            :current-page="page"
            :total="adminNotificationList.length">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import { ITEM_PER_PAGE, SEND_TYPE_PUSH, SEND_TYPE_MAIL } from '@/config'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: 'ListAdminNotification',
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: ``,
        title: 'menu.notification_list',
        page: 1,
        itemPerPage: ITEM_PER_PAGE
      }
    },
    methods: {
      goToDetail(notificationId) {
        this.saveState()
        this.$router.push({path: '/admin-notification/detail', query: {id: notificationId}})
      },
      saveState: function () {
        this.$store.commit('notification/updateAdminNotificationState', {
          page: this.page
        })
      },
      didSelectPage: function (e) {
        this.page = e
      },
      getSendType (sendType) {
        switch (sendType) {
          case SEND_TYPE_PUSH:
            return this.$t('notification.push_notification')
          case SEND_TYPE_MAIL:
            return this.$t('common.email')
          default:
            return this.$t('common.both')
        }
      }
    },
    mounted: function () {
      this.$store.dispatch('notification/retrieveAdminNotificationList', {})
    },
    computed: {
      ...mapState('notification', ['adminNotificationList', 'currentAdminNotificationPage']),
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentAdminNotificationPage) {
          this.page = this.currentAdminNotificationPage
        }

        this.isBack = true
      }

      this.$store.commit('notification/updateAdminNotificationState', {
        page: null
      })
    }
  }
</script>
<style lang="scss">
  .bus-list {
    width: 100%;
    /*border: 1px solid #DCDFE6;*/

    td, th {
      padding: 5px;
    }
  }

  table, th, td {
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
  }

  th {
    height: 55px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
  }

  td {
    height: 40px;
  }
</style>